
import Vue from 'vue';
import Callout from '@/components/Callout.vue';
import { CourseModel } from '@descomplica/dex-models';
import { CourseCertificateModel } from '@/models/studentDocuments';
import CertificateModal from '@/components/modals/certificate/CertificateModal.vue';
import ConfettiAppearing from '@/components/animations/ConfettiAppearing.vue';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import Analytics from '@/helpers/analytics';
import { PostgradEarlyGraduationTrackingInformation } from '@/models/postgradEarlyGraduation/PostgradEarlyGraduationModel';
import { ChimeraCourseModel } from '@/models/chimera/ChimeraCourseModel';

interface Data {
  confettiAppearingAnimationSettings: Record<string, boolean>;
  showCertificateModal: boolean;
}

export default Vue.extend({
  components: {
    Callout,
    CertificateModal,
    ConfettiAppearing,
  },
  data(): Data {
    return {
      confettiAppearingAnimationSettings: {
        startAnimation: false,
        reverseAnimation: false,
        stopAnimation: false,
      },
      showCertificateModal: false,
    };
  },
  computed: {
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
    currentChimeraCourse(): ChimeraCourseModel {
      return this.$store.getters.getCurrentChimeraCourse;
    },
    currentCourseCertificate(): CourseCertificateModel | null {
      return this.$store.getters.certificateByCourseId(this.currentCourse.id);
    },
    certificateDownloadLink(): string {
      return this.currentCourseCertificate?.originalVersionPdfUrl || '';
    },
    loadError(): boolean {
      return (
        !this.currentCourseCertificate?.originalVersionImageUrls.every(Boolean) ||
        !this.currentCourseCertificate.socialVersionImageUrl ||
        !this.currentCourseCertificate.originalVersionPdfUrl
      );
    },
    earlyGraduationTrackingProps(): PostgradEarlyGraduationTrackingInformation {
      return this.$store.getters.earlyGraduationTrackings(this.currentChimeraCourse);
    },
  },
  created(): void {
    Analytics.trackEvent(EVENT_LABELS.documentToastViewed, {
      student_certificate: true,
      course: this.currentCourse.name,
      error: this.loadError,
      ...this.earlyGraduationTrackingProps,
    });
  },
  methods: {
    startPlayer() {
      if (this.loadError) return;

      this.confettiAppearingAnimationSettings = {
        startAnimation: true,
        reverseAnimation: false,
        stopAnimation: false,
      };
    },
    reversePlayer() {
      if (this.loadError) return;

      this.confettiAppearingAnimationSettings = {
        startAnimation: false,
        reverseAnimation: true,
        stopAnimation: false,
      };
    },
    toggleCertificateModal() {
      this.showCertificateModal = !this.showCertificateModal;

      if (!this.showCertificateModal || this.loadError) return;

      this.confettiAppearingAnimationSettings = {
        startAnimation: false,
        reverseAnimation: false,
        stopAnimation: true,
      };
    },
  },
});
